module.exports = __webpack_public_path__ + "static/media/citation_one.19a34c08.usdz";